"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHostedByRedBullProperty = exports.hostedByRedBullPropertyDefinition = void 0;
exports.hostedByRedBullPropertyDefinition = {
    name: 'hosted-by-red-bull',
    type: 'boolean',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    multiple: false,
    default: false,
    view: { label: 'Hosted by Red Bull' },
};
const isHostedByRedBullProperty = (prop) => {
    return prop.name === exports.hostedByRedBullPropertyDefinition.name;
};
exports.isHostedByRedBullProperty = isHostedByRedBullProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9zdGVkLWJ5LXJlZC1idWxsLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvaG9zdGVkLWJ5LXJlZC1idWxsLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsaUNBQWlDLEdBQUc7SUFDL0MsSUFBSSxFQUFFLG9CQUFvQjtJQUMxQixJQUFJLEVBQUUsU0FBUztJQUNmLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsUUFBUSxFQUFFLEtBQUs7SUFDZixPQUFPLEVBQUUsS0FBSztJQUNkLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxvQkFBb0IsRUFBRTtDQUNOLENBQUE7QUFJMUIsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLElBQWtCLEVBQW1DLEVBQUU7SUFDL0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlDQUFpQyxDQUFDLElBQUksQ0FBQTtBQUM3RCxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==